/**
 * Helper that transforms two iterables to a combined generator. The combined generator iterates over the first iterable
 * in full, followed by the second iterable in full
 */
function* combine(...iterables) {
    for (const iterable of iterables) {
        for (const item of iterable) {
            yield item;
        }
    }
}
/**
 * Helper that transforms multiple iterables to a combined generator. The combined generator iterates over all
 * iterables in full, but only yields unique items. This is useful for combining multiple iterables into a single
 * iterable, while ensuring that no duplicates are yielded.
 */
function* unique(...iterables) {
    const tmp = new Set();
    for (const iterable of iterables) {
        for (const item of iterable) {
            if (tmp.has(item)) {
                continue;
            }
            tmp.add(item);
            yield item;
        }
    }
}
export const Iterators = {
    combine,
    unique,
};
//# sourceMappingURL=iterators.js.map